export const initialData = {
    nome: '',
    obrigatorio: false,
    doc_tecnica: false
  }
  export default initialData;
